import { ArrowDown, Droplets, Leaf, Sparkles, Clock } from "lucide-react";
import { IMAGES } from "../data/brand";

const Pill = ({ icon: Icon, label }) => (
  <div className="flex items-center gap-2 px-3 py-1.5 border border-white/10 bg-white/5 backdrop-blur-sm">
    <Icon size={14} className="text-nexa-blue" />
    <span className="text-xs tracking-widest uppercase text-nexa-silver font-medium">{label}</span>
  </div>
);

export default function Hero() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden pt-28 pb-16"
    >
      {/* Background layers: grid + radial spotlight */}
      <div className="absolute inset-0 bg-grid opacity-40" />
      <div className="absolute inset-0 bg-radial-spot" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/30 to-black pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full grid lg:grid-cols-12 gap-12 items-center">
        {/* Left: content */}
        <div className="lg:col-span-7 animate-fade-up">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-px bg-nexa-blue" />
            <span className="overline">Nanotech Waterless Studio • Rieti</span>
          </div>

          <div className="heading text-4xl sm:text-5xl lg:text-7xl leading-[0.95] mb-6">
            <span className="chrome-text">La tua auto,</span>
            <br />
            <span className="text-white">pulita con</span>{" "}
            <span className="text-nexa-blue blue-glow">zero acqua.</span>
          </div>

          <p className="text-base md:text-lg text-nexa-muted max-w-xl leading-relaxed mb-10">
            NexaWash Studio porta il <span className="text-white font-semibold">lavaggio nanotech</span>{" "}
            direttamente alla tua auto. 100% ecologico, senza acqua, brillantezza immediata.
            <span className="text-nexa-blue font-semibold"> Wash &amp; Go.</span>
          </p>

          <div className="flex flex-wrap items-center gap-3 mb-10">
            <Pill icon={Droplets} label="Senza Acqua" />
            <Pill icon={Leaf} label="100% Ecologico" />
            <Pill icon={Sparkles} label="Brillantezza Immediata" />
            <Pill icon={Clock} label="Risparmio Tempo" />
          </div>

          <div className="flex flex-wrap items-center gap-4">
            <button
              onClick={() => scrollTo("preventivo")}
              data-testid="hero-cta-preventivo"
              className="btn-primary"
            >
              Richiedi Preventivo
              <ArrowDown size={16} />
            </button>
            <button
              onClick={() => scrollTo("servizi")}
              data-testid="hero-cta-servizi"
              className="btn-outline"
            >
              Scopri i Servizi
            </button>
          </div>
        </div>

        {/* Right: visual - gazebo image with glow only */}
        <div className="lg:col-span-5 relative animate-fade-up" style={{ animationDelay: "0.3s" }}>
          <div className="relative">
            <div className="absolute -inset-6 bg-nexa-blue/15 blur-3xl" />
            <div className="relative border border-white/10 bg-nexa-surface overflow-hidden">
              <img
                src={IMAGES.gazebo}
                alt="NexaWash Studio - Gazebo Lavaggio Auto Nanotech"
                className="w-full h-auto object-cover block"
                data-testid="hero-gazebo-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-nexa-muted text-xs tracking-[0.3em] uppercase flex flex-col items-center gap-2 animate-float-slow">
        <span>Scroll</span>
        <ArrowDown size={14} />
      </div>
    </section>
  );
}
